goog.provide('el8.appanalytics.dialog.bulkLetterDownload');

goog.require('el8.template.appanalytics.dialog.bulkLetterDownload');
goog.require('el8.uiwidget.NewDialog');

// Dialog to download print pdf or patient list CSV for a bulk letter
el8.appanalytics.dialog.bulkLetterDownload = (function() {

    var timeoutId = null;

    var that = new el8.uiwidget.NewDialog({
        title: 'Download Bulk Letter Document',
        modal: true,
        contentFn: el8.template.appanalytics.dialog.bulkLetterDownload.content,
        closeFn: function() {
            if (timeoutId) {
                window.clearTimeout(timeoutId);
            }
            that.hide();
        },
        showXButton: true,
        height: 175,
        width: 520
    });

    var super_show = that.show;
    that.show = function(bulkLetter, downloadType) {
        super_show.call(that);
        that._contentElt.html(el8.template.appanalytics.dialog.bulkLetterDownload.content());

        if (downloadType === 'contact-list') {
            $.el8_ajax({
                url: el8.service.urls.get('bulkLetterResetContactList', [bulkLetter.id]),
                type: 'POST'
            }).then(function() {
                if (timeoutId) { window.clearTimeout(timeoutId); }
                timeoutId = window.setTimeout(function() {
                    pollForContent(bulkLetter, downloadType);
                }, 5000);
            });
        }
        else {
            if (bulkLetter.print_pdf_status === 'complete') {
                that.hide();
                window.open(bulkLetter.print_pdf_url);
            }
            else {
                pollForContent(bulkLetter, downloadType);
            }
        }
    };

    function pollForContent(bulkLetter, downloadType) {
        if (timeoutId) {
            window.clearTimeout(timeoutId);
            timeoutId = null;
        }

        $.el8_ajax({
            url: el8.service.urls.get('bulkLetter', [bulkLetter.id])
        }).then(function(bulkLetter) {
            var status = null;
            var downloadUrl = null;
            var name = null;
            if (downloadType === 'contact-list') {
                status = bulkLetter.patients_csv_status;
                downloadUrl = bulkLetter.patients_csv_url;
                name = 'Patient List CSV';
            }
            else if (downloadType === 'print') {
                status = bulkLetter.print_pdf_status;
                downloadUrl = bulkLetter.print_pdf_url;
                name = 'Print PDF';
            }

            if (status === 'complete') {
                that._contentElt.html(el8.template.appanalytics.dialog.bulkLetterDownload.done({
                    name: name,
                    url: downloadUrl
                }));
            }
            else if (status === 'failed') {
                that._contentElt.html(el8.template.appanalytics.dialog.bulkLetterDownload.error({
                    name: name
                }));
            }
            else if (status === 'no_output') {
                that._contentElt.html(el8.template.appanalytics.dialog.bulkLetterDownload.noOutput({
                    name: name
                }));
            }
            else {
                timeoutId = window.setTimeout(function() {
                    pollForContent(bulkLetter, downloadType);
                }, 15000);
            }
        });
    }

    return that;

})();
